import React from "react";

/**
 * @component SortGeneralIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <SortGeneralIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const SortGeneralIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="SortGeneralIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M17 6v11h3l-4 4-4-4h3V6h2zM8 3l4 4H9v11H7V7H4l4-4z"
        fillRule="evenodd"
      />
    </svg>
  )
);
SortGeneralIcon.displayName = "SortGeneralIcon";
export default SortGeneralIcon;
